import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Navigate, Route, Routes } from "react-router-dom";

/**
|--------------------------------------------------
| Authentication
|--------------------------------------------------
*/
import Login from "./pages/auth/Login";
import VerifyEmail from "./pages/auth/VerifyEmail";
import ResetPassword from "./pages/auth/ResetPassword";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetEmailSent from "./pages/auth/ResetEmailSent";
import OwnerDetails from "./pages/auth/Registration/OwnerDetails";
import VerifyPasswordReset from "./pages/auth/VerifyPasswordReset";
import SchoolDetails from "./pages/auth/Registration/SchoolDetails";

/**
|--------------------------------------------------
| General
|--------------------------------------------------
*/
import Container from "./layout/Container";
import ClassContainer from "./layout/ClassContainer";
import SchoolContainer from "./layout/SchoolContainer";

/**
 |--------------------------------------------------
 | Users
 |--------------------------------------------------
 */
import Schools from "./pages/Schools";
import Dashboard from "./pages/Dashboard";
import Students from "./pages/users/Students";
import Teachers from "./pages/users/Teachers";
import Calendar from "./pages/curriculum/Calendar";
import SchoolsOwners from "./pages/users/SchoolsOwners";
import AcademicSessions from "./pages/curriculum/AcademicSessions";
import JuniorCurriculum from "./pages/curriculum/JuniorCurriculum";
import SeniorCurriculum from "./pages/curriculum/SeniorCurriculum";

/**
|--------------------------------------------------
| Single School details
|--------------------------------------------------
*/
import Classes from "./pages/school/Classes";
import Invoices from "./pages/payment/Invoices";
import SchoolCalendar from "./pages/school/Calendar";
import SchoolTeachers from "./pages/school/Teachers";
import SchoolDashboard from "./pages/school/Dashboard";
import Billing from "./pages/school/Settings/Billings";
import NewEvent from "./pages/school/Calendar/NewEvent";
import Announcements from "./pages/school/Announcements";
import Notifications from "./pages/school/Notifications";
import EditEvent from "./pages/school/Calendar/EditEvent";
import Attendance from "./pages/school/Classes/Attendance";
import Scorecards from "./pages/school/Classes/Scorecards";
import NewStudent from "./pages/school/Classes/NewStudent";
import NewTeacher from "./pages/school/Teachers/NewTeacher";
import ReportCards from "./pages/school/Classes/ReportCards";
import EditStudent from "./pages/school/Classes/EditStudent";
import ClassDetails from "./pages/school/Classes/ClassDetails";
import Transactions from "./pages/school/Settings/Transactions";
import AdminDetails from "./pages/school/Settings/AdminDetails";
import ClassSubjects from "./pages/school/Classes/ClassSubjects";
import SchoolProfile from "./pages/school/Settings/SchoolProfile";
import BillingInvoice from "./pages/school/Settings/BillingInvoice";
import PendingInvites from "./pages/school/Teachers/PendingInvites";
import Announcement from "./pages/school/Announcements/Announcement";
import Notification from "./pages/school/Notifications/Notification";
import BillingInvoices from "./pages/school/Settings/BillingInvoices";
import StudentReportCard from "./pages/school/Classes/StudentReportCard";
import LeftStudents from "./pages/school/Archives/students/LeftStudents";
import GraduatedStudents from "./pages/school/Archives/students/GraduatedStudents";
import JuniorCurriculums from "./pages/school/Settings/curriculums/JuniorCurriculums";
import SeniorCurriculums from "./pages/school/Settings/curriculums/SeniorCurriculums";
import StudentPreviewReportCard from "./pages/school/Classes/StudentPreviewReportCard";
import ArchivedReportcards from "./pages/school/Archives/reportcards/ArchivedReportcards";
import ClassListForReportcards from "./pages/school/Archives/reportcards/ClassListForReportcards";
import ArchivedReportcardDetails from "./pages/school/Archives/reportcards/ArchivedReportcardDetails";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate replace to="/login" />} />
        <Route path="login" element={<Login />} />

        <Route path="register/personal-details" element={<OwnerDetails />} />
        <Route
          path="register/:schoolOwnerId/school-details"
          element={<SchoolDetails />}
        />

        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="forgot-password/sent" element={<ResetEmailSent />} />
        <Route path="password/reset/:token" element={<VerifyPasswordReset />} />
        <Route path="password/change/:token" element={<ResetPassword />} />
        <Route path="verify/email/:userId/:token" element={<VerifyEmail />} />

        <Route element={<Container />}>
          <Route path="/schools" element={<Schools />} />
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/curriculum/calendar" element={<Calendar />} />
          <Route
            path="/curriculum/academic-sessions"
            element={<AcademicSessions />}
          />
          <Route path="/curriculum/junior" element={<JuniorCurriculum />} />
          <Route path="/curriculum/senior" element={<SeniorCurriculum />} />

          {/**
          |--------------------------------------------------
          | Users
          |--------------------------------------------------
          */}
          <Route path="/users/students" element={<Students />} />
          <Route path="/users/teachers" element={<Teachers />} />
          <Route path="/users/school-owners" element={<SchoolsOwners />} />

          {/**
          |--------------------------------------------------
          | Payment
          |--------------------------------------------------
          */}
          <Route path="/payment/invoices" element={<Invoices />} />
        </Route>

        {/**
        |--------------------------------------------------
        | School
        |--------------------------------------------------
        */}
        <Route element={<SchoolContainer />}>
          <Route path=":schoolId/dashboard" element={<SchoolDashboard />} />

          {/**
          |--------------------------------------------------
          | School teachers
          |--------------------------------------------------
          */}
          <Route path=":schoolId/teachers" element={<SchoolTeachers />} />
          <Route path=":schoolId/teachers/new" element={<NewTeacher />} />
          <Route
            path=":schoolId/teachers/invites"
            element={<PendingInvites />}
          />

          {/**
          |--------------------------------------------------
          | School classes
          |--------------------------------------------------
          */}
          <Route path=":schoolId/classes" element={<Classes />} />
          {/* <Route path=":schoolId/classes/:classId" element={<ClassDetails />} /> */}
          {/* <Route
            path=":schoolId/classes/:classId/students/:studentId/reportcard"
            element={<StudentReportCard />}
          /> */}
          {/* <Route
            path=":schoolId/classes/:classId/students/:studentId/reportcard/:reportcardId"
            element={<StudentPreviewReportCard />}
          /> */}
          {/* <Route
            path=":schoolId/classes/:classId/subjects"
            element={<ClassSubjects />}
          /> */}
          {/* <Route
            path=":schoolId/classes/:classId/attendance"
            element={<Attendance />}
          /> */}
          {/* <Route
            path=":schoolId/classes/:classId/scorecards"
            element={<Scorecards />}
          /> */}
          {/* <Route
            path=":schoolId/classes/:classId/reportcards"
            element={<ReportCards />}
          /> */}
          {/* <Route
            path=":schoolId/classes/:classId/students/new"
            element={<NewStudent />}
          /> */}
          {/* <Route
            path=":schoolId/classes/:classId/student/:studentId"
            element={<EditStudent />}
          /> */}

          {/**
          |--------------------------------------------------
          | School Archives
          |--------------------------------------------------
          */}
          <Route
            path=":schoolId/archives/classes"
            element={<ClassListForReportcards />}
          />
          <Route
            path=":schoolId/archives/classes/:classId/reportcard"
            element={<ArchivedReportcards />}
          />
          <Route
            path=":schoolId/archives/classes/:classId/reportcard/:reportCardId"
            element={<ArchivedReportcardDetails />}
          />
          <Route
            path=":schoolId/archives/graduated-students/:category"
            element={<GraduatedStudents />}
          />
          <Route
            path=":schoolId/archives/left-students"
            element={<LeftStudents />}
          />

          {/**
          |--------------------------------------------------
          | School Calendar
          |--------------------------------------------------
          */}
          <Route
            path=":schoolId/calendar/event/new/:date"
            element={<NewEvent />}
          />
          <Route
            path=":schoolId/calendar/event/edit/:eventId"
            element={<EditEvent />}
          />
          <Route path=":schoolId/calendar" element={<SchoolCalendar />} />

          {/**
          |--------------------------------------------------
          | School Announcements
          |--------------------------------------------------
          */}
          <Route
            path=":schoolId/announcements/:announcementId"
            element={<Announcement />}
          />
          <Route path=":schoolId/announcements" element={<Announcements />} />

          {/**
          |--------------------------------------------------
          | School Notifications
          |--------------------------------------------------
          */}
          <Route
            path=":schoolId/notifications/:notificationId"
            element={<Notification />}
          />
          <Route path=":schoolId/notifications" element={<Notifications />} />

          {/**
          |--------------------------------------------------
          | School Settings
          |--------------------------------------------------
          */}
          <Route path=":schoolId/settings/billing" element={<Billing />} />
          <Route
            path=":schoolId/settings/billing/invoices"
            element={<BillingInvoices />}
          />
          <Route
            path=":schoolId/settings/billing/invoices/:invoiceId"
            element={<BillingInvoice />}
          />
          <Route
            path=":schoolId/settings/billing/transactions"
            element={<Transactions />}
          />
          <Route path=":schoolId/settings/admin" element={<AdminDetails />} />
          <Route path=":schoolId/settings/school" element={<SchoolProfile />} />
          <Route
            path=":schoolId/settings/curriculum/junior"
            element={<JuniorCurriculums />}
          />
          <Route
            path=":schoolId/settings/curriculum/senior"
            element={<SeniorCurriculums />}
          />
        </Route>

        <Route element={<ClassContainer />} path=":schoolId/classes">
          <Route path=":classId" element={<ClassDetails />} />
          <Route
            path=":classId/students/:studentId/reportcard"
            element={<StudentReportCard />}
          />
          <Route
            path=":classId/students/:studentId/reportcard/:reportcardId"
            element={<StudentPreviewReportCard />}
          />
          <Route path=":classId/attendance" element={<Attendance />} />
          <Route path=":classId/scorecards" element={<Scorecards />} />
          <Route path=":classId/subjects" element={<ClassSubjects />} />
          <Route path=":classId/add-student" element={<NewStudent />} />
          <Route path=":classId/reportcards" element={<ReportCards />} />
          <Route path=":classId/student/:studentId" element={<EditStudent />} />
        </Route>
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
